import { fetchOrderDetails } from './orderDetails';
import {
  fetchOrderHistory,
  fetchOrderHistoryOrderDetails,
} from './orderHistory';
import fetchShipmentTrackingDetail from './shipmentTracking';
// import fetchWriteAReviewModalDetail from './writeAReview';
import fetchBodfsShipmentTrackingDetail from './trackYourTruckDelivery';
import {
  submitCancelItems,
  initCancelPage,
  closeBopisModal,
  openBopisModal,
  resetCancelPage,
  bopisCancelSuccess,
} from './onlineCancel';
import {
  handleGiftCardError,
  handleMultiVendorError,
  fetchReturnEligibility,
  noPaymentMethodError,
} from './onlineReturns';
import {
  resetApplianceRescheduleActionData,
  onClickApplianceCalendarUpdateMonth,
  onClickDeliveryDate,
  fetchAvailableDeliverySlots,
  fetchCOMAvailableDeliverySlots,
  submitApplianceReschedule,
  submitCOMApplianceReschedule,
  fetchApplianceCancelEligibility,
  requestApplianceCancellation,
  resetApplianceActionError,
} from './appliance';

import { validInput, resetInput } from './common';
import { ACTIONS } from '../constants';

/**
 * direct action to open a modal with matching filter
 * @param {*} filter
 */
const openModal = (filter: string) => (dispatch: Function) => {
  dispatch({
    type: ACTIONS.OPEN_MODAL,
    filter,
  });
};

/**
 * direct action to close a modal with matching filter
 * @param {*} filter
 */
const closeModal = (filter: string) => (dispatch: Function) => {
  dispatch({
    type: ACTIONS.CLOSE_MODAL,
    filter,
  });
};

/**
 * direct action to update valid input with matching filter
 * @param {*} filter
 */
const updateValidInput = (filter: string, value: string) => (
  dispatch: Function
) => {
  validInput(dispatch, filter, value);
};

/**
 * direct action to reset input value with matching filter
 * @param {*} filter
 */
const resetInputValue = (filter: string) => (dispatch: Function) => {
  resetInput(dispatch, filter);
};

export {
  fetchOrderDetails,
  fetchOrderHistory,
  fetchOrderHistoryOrderDetails,
  fetchShipmentTrackingDetail,
  fetchBodfsShipmentTrackingDetail,
  // fetchWriteAReviewModalDetail,
  fetchApplianceCancelEligibility,
  fetchAvailableDeliverySlots,
  fetchCOMAvailableDeliverySlots,
  initCancelPage,
  closeBopisModal,
  openBopisModal,
  bopisCancelSuccess,
  handleGiftCardError,
  handleMultiVendorError,
  fetchReturnEligibility,
  noPaymentMethodError,
  submitCancelItems,
  openModal,
  closeModal,
  updateValidInput,
  resetInputValue,
  resetCancelPage,
  resetApplianceRescheduleActionData,
  resetApplianceActionError,
  requestApplianceCancellation,
  onClickApplianceCalendarUpdateMonth,
  onClickDeliveryDate,
  submitApplianceReschedule,
  submitCOMApplianceReschedule,
};
